module.exports = __webpack_public_path__ + "img/meeting.4c9c23d5.png";